// V70.179 — MERKEZİ SİTE / ROUTE REGISTRY (spec v1.1 §0.3)
//
// Veri `hrSiteRegistry.json` içinde; bu dosya yalnız okuma yardımcılarıdır.
// Backend aynı JSON'u `backend/src/config/hrSiteRegistry.js` üzerinden okur —
// iki taraf da AYNI dosyadan beslenir, ikinci bir hardcoded liste YOKTUR (spec §P0.5).
//
// Yeni ekran/route/tab/action eklerken: JSON'a node ekle, `hrSiteRegistry.audit.test.js`
// yeşile dönene kadar bitmiş sayma (spec §0.5 — "Registry kaydı ve permission mapping'i
// olmayan yeni sayfa Definition of Done değildir").

import REGISTRY from './hrSiteRegistry.json';

export const HR_REGISTRY = REGISTRY;
export const HR_NODES = REGISTRY.nodes;
export const HR_REGISTRY_GROUPS = REGISTRY.groups;
export const HR_FIELD_GROUPS = REGISTRY.field_groups;
export const HR_SCOPES = REGISTRY.scopes;
export const HR_ACTIONS = REGISTRY.actions;
export const HR_TO_BE_GROUPS = REGISTRY.to_be_groups;

const BY_ID = new Map(HR_NODES.map(n => [n.id, n]));

export const hrNode = (id) => BY_ID.get(id) || null;

export const hrChildren = (parentId) => HR_NODES.filter(n => n.parent_id === parentId);

/** Bir node'un kök'e kadar olan atalarını (kendisi dahil, kökten yaprağa) döner. */
export const hrPath = (id) => {
  const out = [];
  let cur = BY_ID.get(id);
  while (cur) { out.unshift(cur); cur = cur.parent_id ? BY_ID.get(cur.parent_id) : null; }
  return out;
};

/** Route eşleştirme: `:param` segmentleri joker sayılır (`/HR/staff/:id` ↔ `/HR/staff/12`). */
const routeMatches = (pattern, pathname) => {
  if (!pattern) return false;
  const p = pattern.split('/').filter(Boolean);
  const a = pathname.split('/').filter(Boolean);
  if (p.length !== a.length) return false;
  return p.every((seg, i) => seg.startsWith(':') || seg.toLowerCase() === a[i].toLowerCase());
};

/** Verilen URL'ye karşılık gelen node (alias route'lar dahil). */
export const hrNodeForRoute = (pathname) =>
  HR_NODES.find(n => routeMatches(n.route, pathname) || (n.aliases || []).some(r => routeMatches(r, pathname))) || null;

/** Bir node'un bugün fiilen aradığı menü yetkisi — atalardan devralınır. */
export const hrMenuPerm = (node) => {
  for (const n of hrPath(node.id).reverse()) {
    if (n.as_is && n.as_is.menu_perm) return n.as_is.menu_perm;
  }
  return null;
};

/** Node'un hassasiyet seviyesi sayısal karşılığı (L0=0 … L5=5) — sıralama/filtre için. */
export const hrSensitiveRank = (node) => Number(String(node.sensitive_level || 'L0').replace('L', '')) || 0;

/**
 * Menü ağacı: registry'den grup → görünür sayfa listesi üretir.
 * `hrPageGroups.js` bunu kullanır; sidebar ve sekme şeridi ikinci bir listeye bakmaz.
 */
export const hrMenuGroups = () => HR_REGISTRY_GROUPS.map(g => ({
  ...g,
  items: HR_NODES
    .filter(n => n.group === g.key && n.menu_visible && n.route)
    .map(n => ({
      id: n.id,
      to: n.route,
      label: n.title,
      perm: (n.as_is && n.as_is.menu_perm) || undefined,
      // V70.182 — self grubunda bile GENEL anahtarın (hr_modul) açmadığı sayfa:
      // kendi permission'ı şart. Değerlendirme Görevlerim böyle — Özlük'e taşındı
      // ama arka uç hâlâ yönetim yetkisi istiyor, menüde herkese açılmamalı.
      permRequired: !!n.perm_required,
    })),
}));

/** Registry istatistikleri — Site Haritası ekranı ve raporlama için. */
export const hrRegistryStats = () => {
  const byType = {};
  const byEnforcement = {};
  const bySensitive = {};
  for (const n of HR_NODES) {
    byType[n.node_type] = (byType[n.node_type] || 0) + 1;
    const e = (n.as_is && n.as_is.enforcement) || 'unknown';
    byEnforcement[e] = (byEnforcement[e] || 0) + 1;
    bySensitive[n.sensitive_level] = (bySensitive[n.sensitive_level] || 0) + 1;
  }
  return { total: HR_NODES.length, byType, byEnforcement, bySensitive };
};

export default HR_REGISTRY;
